import {get,post,getBrainmedToken} from "@/api/http";
import {searchHttp,searchHttpDev} from "@/api/config";
// 云课堂 满5分钟增加一次
export const addWebApiChoice = (data) => get('/h5WebApi/lottery/addWebApiChoice.jspx', data);

// 获取用户是否领取云课堂奖励
export const getWebApiActivityInfo = (data) => get('/h5WebApi/lottery/getWebApiActivityInfo.jspx', data);

// 是否开启关闭活动页面
export const getWebApiLottery = (data) => get('/wapi/lottery/getWebApiLottery.do', data);
